import { PropsWithChildren, useEffect, useId, useLayoutEffect, useRef } from 'react';
import { createDurationVitalAttempt } from './createDurationVitalAttempt';

export const PLANS_LIST_FIRST_CONTENT_VITAL = 'plans.list_first_content';

const tracker = createDurationVitalAttempt(PLANS_LIST_FIRST_CONTENT_VITAL);

export const reportActivePlansListFirstContentOutcome = tracker.reportActive;
export const resetPlansListFirstContentAttempts = tracker.reset;

interface PlansListFirstContentProviderProps extends PropsWithChildren {
    context?: Record<string, unknown>;
}

export const PlansListFirstContentProvider = ({
    context,
    children,
}: PlansListFirstContentProviderProps) => {
    const instanceId = useId();
    const startedAtRef = useRef(Date.now());
    const contextRef = useRef(context);
    contextRef.current = context;

    useLayoutEffect(() => {
        tracker.register(instanceId, startedAtRef.current, contextRef.current);
        tracker.updateContext(instanceId, contextRef.current);
    }, [instanceId, context]);

    useEffect(() => {
        return () => {
            tracker.scheduleAbandon(instanceId);
        };
    }, [instanceId]);

    return children;
};

export interface PlansListFirstContentGateProps extends PropsWithChildren {
    context?: Record<string, unknown>;
}

/** Place around PlansList so the vital excludes loading/empty-state gates. */
export const PlansListFirstContentGate = ({
    context,
    children,
}: PlansListFirstContentGateProps) => {
    const reportContextRef = useRef(context);
    reportContextRef.current = context;

    useEffect(() => {
        let cancelled = false;
        let outerFrameId = 0;
        let innerFrameId = 0;

        outerFrameId = requestAnimationFrame(() => {
            innerFrameId = requestAnimationFrame(() => {
                if (cancelled) {
                    return;
                }

                tracker.reportActive('success', reportContextRef.current);
            });
        });

        return () => {
            cancelled = true;
            cancelAnimationFrame(outerFrameId);
            cancelAnimationFrame(innerFrameId);
        };
    }, []);

    return children;
};

/** @deprecated Use PlansListFirstContentGate */
export const ReportPlansListFirstContent = PlansListFirstContentGate;
